import type { MobileCardConfig } from "../Tables/CustomTable/CustomTable";
import { COLORS } from "~/utils/constants";

export const NEVER_PAID_MOBILE_CONFIG: MobileCardConfig = {
  headlineKeys: ["tenant", "unit"],
  primaryKeys: ["balanceDue", "expectedRent"],
};

export const IN_PROGRESS_MOBILE_CONFIG: MobileCardConfig = {
  headlineKeys: ["tenant", "unit"],
  primaryKeys: ["balanceDue", "inProgressReason"],
};

export const RENT_DUE_HEADER_STYLES = {
  neverPaid: {
    header: {
      backgroundColor: "rgba(255, 44, 44, 0.1)",
      borderLeft: `4px solid ${COLORS.red}`,
      borderRadius: 4,
    },
  },
  inProgress: {
    header: {
      backgroundColor: "rgba(75, 155, 192, 0.12)",
      borderLeft: `4px solid ${COLORS.baby_blue}`,
      borderRadius: 4,
    },
  },
} as const;

export type RentDueVariant = keyof typeof RENT_DUE_HEADER_STYLES;
